const { ValidationError } = require('@plastiq/external-api-errors')

const BaseValidator = require('./BaseValidator')

class BooleanValidator {
  static validate(argument, argumentName) {
    BaseValidator.guardAgainstNullOrUndefined(argument, argumentName)
    if (typeof argument !== 'boolean') {
      throw new ValidationError(`Must be of type boolean: ${argumentName}`)
    }
  }
}

module.exports = BooleanValidator
